

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
    Button,
    Dialog,
    DialogContent,
    DialogContentText,
    Typography,
    IconButton
} from '@mui/material';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import ErrorBoundary from './ErrorBoundary';
import CellModalContent from './CellModalContent';

const DialogTitleRoot = styled('div')(({ theme }) => ({
    margin: 0,
    padding: theme.spacing(2),
    position: 'relative',
}));

const CloseButton = styled(IconButton)(({ theme }) => ({
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
}));

const CellModal = ({ value, title }) => {
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <div>
            <Button onClick={handleClickOpen} color="primary" size="small" variant="outlined">
                View
            </Button>

            <Dialog
                open={open}
                onClose={handleClose}
                scroll="paper"
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <DialogTitleRoot>
                    <Typography variant="h6">{title}</Typography>
                    <CloseButton aria-label="close" onClick={handleClose} size="large">
                        <CloseIcon />
                    </CloseButton>
                </DialogTitleRoot>

                <DialogContent dividers>
                    <DialogContentText
                        id="scroll-dialog-description"
                        tabIndex={-1}
                        component="span"
                    >
                        <ErrorBoundary>
                            <CellModalContent value={value} title={title} />
                        </ErrorBoundary>
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        </div>
    );
};

CellModal.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ]).isRequired,
    title: PropTypes.string.isRequired,
};

export default CellModal;
